export type ValueType = 'integer' | 'decimal' | 'currency' | 'percentage';
export type DisplayVariant = 'metric' | 'footer';

export enum Status {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  NEUTRAL = 'neutral'
}

export enum Direction {
  UP = 'up',
  DOWN = 'down',
  NEUTRAL = 'neutral'
}

export enum FormulaName {
  MIN_LEADS_FROM_BUDGET = 'min_leads_from_budget',
  MIN_START_TRIAL_OUTBOUND = 'min_start_trial_outbound',
  MIN_START_TRIAL_INBOUND = 'min_start_trial_inbound',
  MIN_CLOSES_OUTBOUND = 'min_closes_outbound',
  MIN_CLOSES_INBOUND = 'min_closes_inbound'
}

export enum RangeValueType {
  STATIC = 'static',
  CALCULATED = 'calculated'
}

export interface MetricRangeValueResponseDto {
  value: number | null;
  type: RangeValueType;
  calculationFormula: FormulaName | null;
}

export interface MetricValueResponseDto {
  metricKey: string;
  label: string;
  value: number | null;
  valueType: ValueType;
  displayVariant: DisplayVariant;
  status: Status;
  min: MetricRangeValueResponseDto | null;
  max: MetricRangeValueResponseDto | null;
  deltaPercentage: number | null;
  deltaDirection: Direction | null;
  isDeltaInverted: boolean;
}

export interface CardResponseDto {
  cardKey: string;
  label: string;
  icon?: string;
  metrics: MetricValueResponseDto[];
}

export interface SectionResponseDto {
  sectionKey: string;
  label: string;
  cards: CardResponseDto[];
}

export interface DashboardResponseDto {
  dashboardKey: string;
  year: number;
  calendarWeek: number;
  sections: SectionResponseDto[];
}

export interface MetricYearMonthRangeResponseDto {
  year: number;
  month: number;
}

export interface MetricYearMonthDetailsRangeResponseDto {
  from: MetricYearMonthRangeResponseDto;
  to: MetricYearMonthRangeResponseDto;
}

export interface MetricYearWeekRangeResponseDto {
  year: number;
  week: number;
}

export interface MetricYearWeekDetailsRangeResponseDto {
  from: MetricYearWeekRangeResponseDto;
  to: MetricYearWeekRangeResponseDto;
}

export interface MetricDetailsItemResponseDto extends MetricYearWeekRangeResponseDto {
  value: number;
}

export interface MetricDetailsResponseDto extends MetricYearWeekDetailsRangeResponseDto {
  items: MetricDetailsItemResponseDto[];
}

export interface CacDetailsItemResponseDto extends MetricYearMonthRangeResponseDto {
  value: number;
}

export interface CacDetailsResponseDto extends MetricYearMonthDetailsRangeResponseDto {
  items: CacDetailsItemResponseDto[];
}

export interface CacResponseDto {
  value: number | null;
  deltaPercentage: number | null;
  deltaDirection: Direction | null;
}

export interface SectionMetaResponseDto {
  title: string;
  sectionKey: string;
  cardCount: number;
  cards: CardMetaResponseDto[];
}

export interface CardMetaResponseDto {
  cardKey: string;
  title: string;
  values: ValueMetaResponseDto[];
}

export interface ValueMetaResponseDto {
  metricKey: string;
  title: string;
  valueType: ValueType;
}

export interface KpiDashboardMetaResponseDto {
  years: FilterMetaYearResponseDto[];
  currentYear: number;
  currentWeek: number;
  currentMonth: number;
  sections: SectionMetaResponseDto[];
  title: string;
  description: string;
}

export interface FilterMetaYearResponseDto {
  year: number;
  weeks: number[];
  months: FilterMetaMonthResponseDto[];
}

export interface FilterMetaMonthResponseDto {
  month: number;
  title: string;
  weeks: number[];
}
